import {
  InputField,
  UploadImageField,
  LoaderButton
} from 'components/molecules'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import { Form, Formik, FieldArray } from 'formik'
import ProductCollectionAsyncMultiselectField from 'domains/product-collection/molecules/async-multiselect-field'
import PropTypes from 'prop-types'
import React from 'react'
import { Row, Col, Button } from 'reactstrap'

const propTypes = {
  featured_seller: PropTypes.shape({
    seller: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    inspired_look: PropTypes.shape({
      hero_image_url : PropTypes.string,
      outfits        : PropTypes.FieldArray
    }),
    favourite_brand_thumbnail_image_url : PropTypes.string,
    inspired_look_thumbnail_image_url   : PropTypes.string
  }),
  inspiredLookHeroImage             : PropTypes.object,
  mainPageThumbnailImage            : PropTypes.object,
  favouriteBrandThumbnailImage      : PropTypes.object,
  tempInspiredLookOutfitImage       : PropTypes.object,
  inspiredLookOutfitImages          : PropTypes.array,
  setInspiredLookHeroImageHeroImage : PropTypes.func,
  setMainPageThumbnailImage         : PropTypes.func,
  setFavouriteBrandThumbnailImage   : PropTypes.func,
  setTempInspiredLookOutfitImage    : PropTypes.func,
  setInspiredLookOutfitImages       : PropTypes.func,
  handleSubmitForm                  : PropTypes.func.isRequired
}

const defaultProps = {
  featured_seller: {
    seller: {
      id       : 0,
      name     : '',
      username : '',
      url_key  : ''
    },
    inspired_look: {
      hero_image_url : '',
      outfits        : []
    },
    main_page_thumbnail_image_url     : '',
    inspired_look_thumbnail_image_url : ''
  },
  inspiredLookHeroImage             : new Blob(),
  mainPageThumbnailImage            : new Blob(),
  favouriteBrandThumbnailImage      : new Blob(),
  tempInspiredLookOutfitImage       : new Blob(),
  inspiredLookOutfitImages          : [],
  setInspiredLookHeroImageHeroImage : () => {},
  setMainPageThumbnailImage         : () => {},
  setFavouriteBrandThumbnailImage   : () => {},
  setTempInspiredLookOutfitImage    : () => {},
  setInspiredLookOutfitImages       : () => {},
  handleSubmitForm                  : () => {}
}

/**
 * Form to edit CMS Featured Seller Inspired Look
 */

const CmsFeaturedSellerInspiredLookForm = ({
  featured_seller,
  inspiredLookHeroImage,
  mainPageThumbnailImage,
  favouriteBrandThumbnailImage,
  inspiredLookOutfitImages,
  tempInspiredLookOutfitImage,
  setInspiredLookHeroImageHeroImage,
  setMainPageThumbnailImage,
  setFavouriteBrandThumbnailImage,
  setTempInspiredLookOutfitImage,
  setInspiredLookOutfitImages,
  handleSubmitForm
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={ featured_seller }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <>
          <h3>
            { 'Go to Featured Seller Inspired Look page ' }
            <a
              className='text-primary'
              href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/featured-sellers/${formikBag.values.seller.url_key}/inspired-looks` }
              target='_blank' rel='noopener noreferrer'
            >
              { 'here' }
            </a>
          </h3>

          <Form>
            <UploadImageField
              id='output-inspired-look-hero-image'
              label='Cover Image'
              required={ true }
              image={ inspiredLookHeroImage }
              initialImageSrc={ formikBag.values.inspired_look.hero_image_url }
              setValue={ (input) => {
                setInspiredLookHeroImageHeroImage(input)
              } }
            />

            <FieldArray name={ 'inspired_look.outfits' }>
              { ({ remove, push }) => (
                <>
                  <div>
                    {
                      formikBag.values.inspired_look.outfits.map((attribute, index) => (
                        <div key={ `${attribute}-${index}` } style={{ marginBottom: '30px' }}>
                          <Row>
                            <Col lg = '12'>
                              <h3><u>{ `Outfit ${index+1}` }</u></h3>
                              <InputField
                                type='text'
                                label='Title'
                                placeholder='Retro Chic'
                                name={ `inspired_look.outfits[${index}].title` }
                              >
                              </InputField>

                              <UploadImageField
                                id={ `output-inspired-look-outfit-image-${index+1}` }
                                label='Image'
                                required={ true }
                                isMultiple={ true }
                                images={ inspiredLookOutfitImages }
                                imageIndex= { index }
                                setImages={ setInspiredLookOutfitImages }
                                image={ tempInspiredLookOutfitImage }
                                initialImageSrc={ formikBag.values.inspired_look.outfits[index].image_url }
                                setValue={ (input) => {
                                  setTempInspiredLookOutfitImage(input)
                                } }
                              />

                              <InputField
                                type='textarea'
                                rows='5'
                                label='Description'
                                name={ `inspired_look.outfits[${index}].description` }
                              >
                              </InputField>

                              <ProductCollectionAsyncMultiselectField
                                name={ `inspired_look.outfits[${index}].collection_id` }
                                label='Product Collection'
                                placeholder='Select Collection'
                                isMultiple={ false }
                              />
                            </Col>
                          </Row>

                          <Button
                            className='mb-4'
                            color='danger'
                            onClick={ () => remove(index) }
                          >
                            { 'Remove Field' }
                          </Button>
                          <hr style={{ border: '10px solid #e5e5e5' }}></hr>
                        </div>
                      ))
                    }
                  </div>

                  <div className='mb-2'>
                    <Button
                      color='success'
                      onClick={ () => push({ title: '', description: '', collection_id: '', image: new Blob() })  }
                    >
                      { 'Add New Inspired Look Outfit' }
                    </Button>
                  </div>
                </>
              ) }
            </FieldArray>

            <UploadImageField
              id='output-main-page-thumbnail-image'
              label='Main Page Thumbnail Image'
              image={ mainPageThumbnailImage }
              initialImageSrc={ formikBag.values.main_page_thumbnail_image_url }
              setValue={ (input) => {
                setMainPageThumbnailImage(input)
              } }
            />

            <UploadImageField
              id='output-favourite-brand-thumbnail-image'
              label='Favourite Brand Thumbnail Image'
              image={ favouriteBrandThumbnailImage }
              initialImageSrc={ formikBag.values.favourite_brand_thumbnail_image_url }
              setValue={ (input) => {
                setFavouriteBrandThumbnailImage(input)
              } }
            />

            <Row >
              <Col>
                <LoaderButton
                  className='float-right'
                  color='success'
                  isLoading={ formikBag.isSubmitting }
                  onClick={ formikBag.submitForm }
                  text={ 'Save' }
                />
              </Col>
            </Row>

          </Form>
        </>
      )
    }
  </Formik>
)

CmsFeaturedSellerInspiredLookForm.propTypes    = propTypes
CmsFeaturedSellerInspiredLookForm.defaultProps = defaultProps

export default CmsFeaturedSellerInspiredLookForm
